import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  branch,
  compose,
  getContext,
  setPropTypes,
  withProps,
  withStateHandlers
} from 'recompose'
import { noop, range } from 'lodash'
import { withElementRef } from 'src/composables'
import { selectHighestRateLoanDictionary } from 'src/store/selectors/home/dictionary'
import {
  selectExtraPaymentSavingsCalculator,
  selectExtraPaymentSavedYearsCalculator
} from 'src/store/selectors/home/dictionary'
import { PrincipalPayments } from 'src/constants/notificationRefs'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool
}

const propTypes = {
  initialPayment: PropTypes.number, // override initial state

  // ignored if withCurrentHomeData
  addPayment: PropTypes.number,
  addPaymentSavings: PropTypes.number,
  addPaymentSavingsYears: PropTypes.number,
  setAddPayment: PropTypes.func
}

const principalOptions = [...range(50, 1000, 50), ...range(1000, 3000, 250)]

const calcInitialPayment = dictionary => {
  let nearestOption = principalOptions[0]
  const payment = dictionary.initialDIYPayment()

  principalOptions.find(option => {
    if (option > payment) {
      return true
    }
    nearestOption = option
    return false
  })

  return nearestOption
}

const composeWithHomeData = compose(
  connect(state => ({
    dictionary: selectHighestRateLoanDictionary(state),
    calcSavings: selectExtraPaymentSavingsCalculator(state),
    calcSavedYears: selectExtraPaymentSavedYearsCalculator(state)
  })),
  withStateHandlers(
    ({ initialAddPayment: addPayment, dictionary }) => ({
      addPayment: addPayment || calcInitialPayment(dictionary)
    }),
    { setAddPayment: () => addPayment => ({ addPayment }) }
  ),
  withProps(({ addPayment, calcSavings, calcSavedYears }) => ({
    addPaymentSavings: calcSavings(addPayment),
    addPaymentSavingsYears: calcSavedYears(addPayment)
  })),
  withElementRef(PrincipalPayments)
)

const composeWithoutHomeData = withProps(props => ({
  addPayment: 250,
  addPaymentSavings: 47000,
  addPaymentSavingsYears: 12,
  setAddPayment: noop
}))

const PrincipalPaymentsContainer = compose(
  getContext(contextTypes),
  setPropTypes(propTypes),
  withProps(() => ({
    principalOptions
  })),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  )
)

export default PrincipalPaymentsContainer
